import React from 'react';
import {Paper, Typography} from "@mui/material";

import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import BackOrdersList from '../lists/backOrdersList';



const BackOrdersPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Items Awaiting Delivery
      </Typography>
      
      <Paper sx={{my: 5}}>
        <BackOrdersList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default BackOrdersPage